<template>
  <row class="loginForm">
    <column class="col-md-4"></column>
    <column class="col-md-4">
      <h2 class="widget-user-username" style="margin-left: 0px;">{{title}}</h2>

      <va-box title="Login" theme="box-info" :isBorder="true" widgetType="">
        <div slot="content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label">Email</label>
              <div class="col-sm-10">
                <input type="email" class="form-control" placeholder="Email" v-model="username" @keyup="loginKeyup($event)" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">Password</label>
              <div class="col-sm-10">
                <input type="password" class="form-control" placeholder="Password" v-model="password" @keyup="loginKeyup($event)" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label"></label>
              <div class="col-sm-10" style="text-align: right; cursor: pointer;">
                <a class="control-label" @click="sendResetPassword()">Reset Password</a>
              </div>
            </div>
            <div class="tree-content tree--small col-sm-offset-2 col-sm-10" style="float: left!important;" @click="rememberMe=!rememberMe">
              <i :class="['tree-checkbox', rememberMe?'checked':'']"></i>
              <span tabindex="-1" class="tree-anchor">
                <span class="tree-text" style="white-space: nowrap;">Remember me</span>
              </span>
            </div>
            <!--<va-checkbox :isHorizontal="true" v-model="rememberMe" text="Remember me"></va-checkbox>-->
          </form>
        </div>
        <div slot="footer">
          <va-button :isBlock="false" theme="primary" name="Register" @click.native="register"></va-button>
          <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
          <va-button :isBlock="false" theme="success" align="right" name="Login" @click.native="login" style="margin-right: 10px;"></va-button>
        </div>
      </va-box>
      <va-alert :type="alertType" :dismissible="true" v-show="error">
        <div slot="body">
          <i v-if="alertType==='success'" class="icon fa fa-check"></i>
          <i v-else class="icon fa fa-ban"></i> {{error}}
        </div>
      </va-alert>
    </column>
    <column class="col-md-4"></column>
  </row>
</template>

<script>
  import VAAlert from '../components/VAAlert'
  import VABox from '../components/VABox'
  import VACheckBox from '../components/VACheckBox'
  import VAButton from '../components/VAButton'
  import VAFormGroup from '../components/VAFormGroup'

  import { db, auth } from '../firebase'

  export default {
    name: 'va-login',
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        username: '',
        password: '',
        error: '',
        rememberMe: true,
        alertType: 'danger'
      }
    },
    created () {
      this.$root.logout()
    },
    components: {
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-checkbox': VACheckBox,
      'va-button': VAButton,
      'va-form-group': VAFormGroup
    },
    methods: {
      sendResetPassword () {
        const vm = this
        console.log('sendResetPassword')
        auth.sendPasswordResetEmail(vm.username).then(() => {
          console.log('email sent!')
          vm.alertType = 'success'
          vm.error = 'Reset Password link was sent to your email.'
          window.setTimeout(function () { vm.error = '' }, 3000)
        }).catch(function (error) {
          console.log(error)
          vm.alertType = 'danger'
          vm.error = error.message
        })
      },
      loginKeyup (event) {
        // console.log('loginKeyup')
        if (event.keyCode === 13) {
          // console.log('Enter')
          event.preventDefault()
          this.login()
        }
      },
      login () {
        console.log('login')
        const vm = this
        vm.$root.logout()
        vm.$root.hasAnnouncement = false
        vm.$root.isFirstLogin = false
        if (vm.isValidLogin(vm.username, vm.password)) {
          auth.signInWithEmailAndPassword(vm.username, vm.password).then(function () {
            console.log(auth.currentUser)
            vm.isVerifiedUID(auth.currentUser.uid, function (isVerified) {
              // ByPass all Email verifications
              isVerified = true
              if (isVerified) {
                const userRef = db.ref('Users/' + auth.currentUser.uid)
                userRef.once('value').then(function (snapUser) {
                  let userData = snapUser.val()
                  // providerData
                  console.log(userData)
                  if (userData) {
                    if (!userData.Locked) {
                      if (!userData.LastLogin) {
                        vm.$root.isFirstLogin = true
                      } else {
                        vm.$root.isFirstLogin = false
                      }
                      userData['.key'] = auth.currentUser.uid
                      userData.Connected = true
                      vm.$root.user = userData
                      db.ref('Users/' + auth.currentUser.uid + '/Connected').set(true)
                      db.ref('Users/' + auth.currentUser.uid + '/LastLogin').set(vm.$moment().format('DD/MM/YYYY HH:mm:ss'))
                      if (!userData.Verified && auth.currentUser.emailVerified) {
                        db.ref('Users/' + auth.currentUser.uid + '/Verified').set(auth.currentUser.emailVerified)
                        vm.$root.user.Verified = auth.currentUser.emailVerified
                      }
                      console.log(vm.$root.user)
                      vm.$localStorage.set('user', JSON.stringify(vm.$root.user))
                      vm.$root.checkUser()
                    } else {
                      vm.alertType = 'danger'
                      vm.error = '* Login failed, your account is Locked!'
                      setTimeout(function () { vm.$root.hasAnnouncement = true }, 2000)
                    }
                  } else {
                    vm.alertType = 'danger'
                    vm.error = '* Login failed, please try again!'
                  }
                })
              } else {
                auth.signOut()
                vm.alertType = 'danger'
                vm.error = '* Your email address is NOT verified, Please check your inbox!'
              }
            })
          }, function (error) {
            vm.alertType = 'danger'
            vm.error = error.code + ': ' + error.message
          })
        }
      },
      cancel () {
        console.log('cancel')
        const vm = this
        vm.username = ''
        vm.password = ''
        // location.reload(true)
        vm.$root.goto('Home')
      },
      register () {
        console.log('register')
        const vm = this
        vm.username = ''
        vm.password = ''
        vm.$root.goto('Register')
      },
      isValidLogin (username, password) {
        this.error = ''
        if (username.length > 0) {
          if (password.length > 0) {
            return true
          }
        }
        this.alertType = 'danger'
        this.error = '* Please enter Email and Password !'
        return false
      },
      isVerifiedUID (uid, callback) {
        db.ref('Verifications/' + uid).orderByKey().once('value').then(function (snapVerificationUser) {
          let verificationData = snapVerificationUser.val()
          if (verificationData) {
            callback(false)
          } else {
            callback(true)
          }
        }).catch((err) => {
          console.log(err)
          callback(false)
        })
      },
      isVerifiedEmail (email, callback) {
        db.ref('Verifications').orderByChild('Email').equalTo(email).limitToLast(1).once('value').then(function (snapVerificationUser) {
          let verificationData = snapVerificationUser.val()
          if (verificationData) {
            callback(false)
          } else {
            callback(true)
          }
        }).catch((err) => {
          console.log(err)
          callback(false)
        })
      },
      isVerifiedEmail00 (email, callback) {
        // https://b-info.firebaseio.com/Verifications
        db.ref('Users').orderByChild('Email').equalTo(email).once('value').then(function (snapUser) {
          let userData = snapUser.val()
          if (userData) {
            // User Email does exist
            db.ref('Verifications').orderByChild('Email').equalTo(email).limitToLast(1).once('value').then(function (snapVerificationUser) {
              let verificationData = snapVerificationUser.val()
              if (verificationData) {
                callback(false)
              } else {
                callback(true)
              }
            }).catch((err) => {
              console.log(err)
              callback(false)
            })
          } else {
            callback(true)
          }
        })
      },
      checkBlockedUser () {
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VALogin.vue?9f85be1c